var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeframe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 527.681,
    height: 66.865,
    viewBox: "0 0 527.681 66.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke: #ff8200;\r\n        stroke-width: 0.75px;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0.8;\r\n      }\r\n\r\n      .cls-2 {\r\n        opacity: 0.5;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: 0.2;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-6 {\r\n        filter: url(#Trazado_219-2);\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#Trazado_218-2);\r\n      }\r\n\r\n      .cls-8 {\r\n        filter: url(#Trazado_217-2);\r\n      }\r\n\r\n      .cls-9 {\r\n        filter: url(#Trazado_219);\r\n      }\r\n\r\n      .cls-10 {\r\n        filter: url(#Trazado_218);\r\n      }\r\n\r\n      .cls-11 {\r\n        filter: url(#Trazado_217);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_217",
    x: 385.612,
    y: 0.322,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_218",
    x: 412.86,
    y: 0,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_219",
    x: 440.108,
    y: 0,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.856,
    y1: -0.24,
    x2: 0.115,
    y2: 1.109,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_217-2",
    x: 74.59,
    y: 3.606,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_218-2",
    x: 47.343,
    y: 3.284,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_219-2",
    x: 20.095,
    y: 3.284,
    width: 57.478,
    height: 63.259,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0300"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.144,
    y1: -0.24,
    x2: 0.885,
    y2: 1.109,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Frame_ComingSoon",
    transform: "translate(-701.16 -818.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(966.363 823.672)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11",
    transform: "matrix(1, 0, 0, 1, -265.2, -5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217-3",
    "data-name": "Trazado 217",
    className: "cls-1",
    d: "M-13.077,0-25.86,12.956V24.028l-1.415,1.434v7.047h1.395L-.547,6.832V0Z",
    transform: "translate(428.26 15.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10",
    transform: "matrix(1, 0, 0, 1, -265.2, -5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218-3",
    "data-name": "Trazado 218",
    className: "cls-2",
    d: "M-13.077,0-25.86,12.956V24.028l-1.415,1.434v7.047h1.395L-.547,6.832V0Z",
    transform: "translate(455.51 15.38)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9",
    transform: "matrix(1, 0, 0, 1, -265.2, -5.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219-3",
    "data-name": "Trazado 219",
    className: "cls-3",
    d: "M-13.077,0-25.86,12.956V24.028l-1.415,1.434v7.047h1.395L-.547,6.832V0Z",
    transform: "translate(482.76 15.38)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220",
    "data-name": "Trazado 220",
    className: "cls-4",
    d: "M1594.4-161.329H1492.124v-.472H1594.2l41.944-42.156H1754.6v.472H1636.341Z",
    transform: "translate(-1492.124 203.957)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_47",
    "data-name": "Grupo 47",
    transform: "translate(731.16 826.956)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8",
    transform: "matrix(1, 0, 0, 1, -30, -8.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_217-4",
    "data-name": "Trazado 217",
    className: "cls-1",
    d: "M-14.745,0-1.963,12.956V24.028l1.415,1.434v7.047H-1.942L-27.275,6.832V0Z",
    transform: "translate(117.24 18.98)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, -30, -8.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_218-4",
    "data-name": "Trazado 218",
    className: "cls-2",
    d: "M-14.745,0-1.963,12.956V24.028l1.415,1.434v7.047H-1.942L-27.275,6.832V0Z",
    transform: "translate(89.99 18.66)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, -30, -8.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_219-4",
    "data-name": "Trazado 219",
    className: "cls-3",
    d: "M-14.745,0-1.963,12.956V24.028l1.415,1.434v7.047H-1.942L-27.275,6.832V0Z",
    transform: "translate(62.74 18.66)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_220-2",
    "data-name": "Trazado 220",
    className: "cls-5",
    d: "M1612.329-161.329H1714.6v-.472H1612.526l-41.944-42.156H1462.125v.472h108.261Z",
    transform: "translate(-1492.125 203.957)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeframe);
export default __webpack_public_path__ + "static/media/homeframe.5ab2ba64fe11c4a2896ade8b0f9e2d7a.svg";
export { ForwardRef as ReactComponent };